import { getUniqueName } from '@/utils/getUniqueName';

import { NEW_DASHBOARD_NAME } from '../constants/const';

export const getUniqueDashboardName = (existingNames: string[]): string => {
  return getUniqueName(existingNames, NEW_DASHBOARD_NAME);
};

export default getUniqueDashboardName;
